import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import React from 'react';
import {
  List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { Folder } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
}));


export default function AttachmentsList({
  attachments,
  onDelete,
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {attachments.length > 0 ? (
        <List dense>
          {attachments
            .map(a => (
              <ListItem>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar>
                      <Folder />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={a.attr('name')} />
                </ListItem>
                <ListItemSecondaryAction>
                  <IconButton
                    test="delete-document"
                    edge="end"
                    aria-label="delete"
                    color="primary"
                    onClick={() => onDelete(a)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
      ) : null }
    </div>
  );
}

AttachmentsList.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.func,
};

AttachmentsList.defaultProps = {
  onDelete: () => {},
};
